<template>
<div class="cooperation">
  <div class="swiper1">
    <swiper style="margin: 0 78px;" ref="cooperationSwiper" :options="swiperOptions">
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/1.png" width="100%" alt="">
        <img src="../../../assets/images/logos/6.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/2.png" width="100%" alt="">
        <img src="../../../assets/images/logos/7.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/3.png" width="100%" alt="">
        <img src="../../../assets/images/logos/8.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/4.png" width="100%" alt="">
        <img src="../../../assets/images/logos/9.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/5.png" width="100%" alt="">
        <img src="../../../assets/images/logos/10.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/11.png" width="100%" alt="">
        <img src="../../../assets/images/logos/12.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/13.png" width="100%" alt="">
        <img src="../../../assets/images/logos/14.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/15.png" width="100%" alt="">
        <img src="../../../assets/images/logos/16.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/17.png" width="100%" alt="">
        <img src="../../../assets/images/logos/18.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/19.png" width="100%" alt="">
        <img src="../../../assets/images/logos/20.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/21.png" width="100%" alt="">
        <img src="../../../assets/images/logos/22.png" width="100%" alt="">
      </swiper-slide>
    </swiper>
    <div class="cooswiper-button-prev" slot="button-prev"></div>
    <div class="cooswiper-button-next" slot="button-next"></div>
  </div>
  <div class="swiper2">
    <swiper style="margin: 0 40px;" ref="cooperationSwiper" :options="swiperOptions2">
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/1.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/2.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/3.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/4.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/5.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/6.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/7.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/8.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/9.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/10.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/11.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/12.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/13.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/14.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/15.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/16.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/17.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/18.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/19.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/20.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/21.png" width="100%" alt="">
      </swiper-slide>
      <swiper-slide class="item">
        <img src="../../../assets/images/logos/22.png" width="100%" alt="">
      </swiper-slide>
    </swiper>
    <div class="cooswiper-button-prev" slot="button-prev"></div>
    <div class="cooswiper-button-next" slot="button-next"></div>
  </div>
</div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  name: 'HomeCooperation',
  data() {
    return {
      swiperOptions: {
        autoplay: true,
        loop: true,
        slidesPerView: 4,
        spaceBetween: 12,
        navigation: {
          nextEl: '.cooswiper-button-next',
          prevEl: '.cooswiper-button-prev'
        }
      },
      swiperOptions2: {
        autoplay: true,
        loop: true,
        slidesPerView: 2,
        spaceBetween: 24,
        navigation: {
          nextEl: '.cooswiper-button-next',
          prevEl: '.cooswiper-button-prev'
        }
      }
    }
  },
}
</script>

<style scoped>
.cooperation {
  position: relative;
  padding: 20px 0;
  height: auto;
  overflow: hidden;
}

.cooperation .item img {
  box-sizing: border-box;
  margin: 12px 0;
  width: 100%;
  border: solid 1px #f2f2f2;
}

.cooperation .cooswiper-button-prev,
.cooperation .cooswiper-button-next {
  position: absolute;
  top: 50%;
  margin-top: -18px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.cooperation .cooswiper-button-prev {
  left: 24px;
  background-image: url(../../../assets/images/a1_2.png);
}
.cooperation .cooswiper-button-prev:hover {
  background-image: url(../../../assets/images/a2_2.png);
}
.cooperation .cooswiper-button-next {
  right: 24px;
  background-image: url(../../../assets/images/a1_1.png);
}
.cooperation .cooswiper-button-next:hover {
  background-image: url(../../../assets/images/a2_1.png);
}
.swiper2 {
  display: none;
}

@media screen and (max-width: 1000px) {
  .swiper1 {
    display: none;
  }
  .swiper2 {
    display: block;
  }

  .cooperation .cooswiper-button-prev,
  .cooperation .cooswiper-button-next {
    background-size: 80% 80%;
  }
  .cooperation .item img {
    margin: 8px 0;
  }
  .cooperation .cooswiper-button-prev {
    left: 0;
  }
  .cooperation .cooswiper-button-next {
    right: 0;
  }
}
</style>
